import { Reducer } from 'redux';

import { changeExchangeInfo } from './exchangeInfo';
// import { Chains } from './exchangeActiveChainUtils';

// Actions

// export const changeExchangeNativeAssetUsdPrice = (usdPrice: string) => ({
//   type: 'CHANGE_EXCHANGE_NATIVE_ASSET_USD_PRICE' as const,
//   usdPrice: Number(usdPrice),
// });

// export const changeOtherChains24hVolumes = (
//   payload: { chain: Chains; volume: string }[]
// ) => ({
//   type: 'LOAD_OTHER_CHAIN_24H_VOLUMES' as const,
//   payload,
// });

type ExchangeInfoAction = ReturnType<
  typeof changeExchangeInfo
  // | typeof changeExchangeNativeAssetUsdPrice
  // | typeof changeOtherChains24hVolumes
>;

// Reducer

type ExchangeInfoStats = {
  // Chain specific asset price - eg. ETH, BNB
  // readonly nativeAssetUsdPrice?: number;
  // readonly idexUsdcTokenPrice?: number;

  readonly katanaChainVolume24hUsd?: string;
  // readonly etherumVolume24hUsd?: string;
  // readonly binanceChainVolume24hUsd?: string;

  totalOpenInterest?: string;
  totalTrades?: number;
  totalVolume?: string;

  // All chains agregated volume // readonly agregated24hUsdVolume?: number;
};

/** Dynamic data from exchange endpoint, live updated with pooling */
export const exchangeInfoStatsReducer: Reducer<
  ExchangeInfoStats,
  ExchangeInfoAction
> = (state: ExchangeInfoStats = {}, action): ExchangeInfoStats => {
  switch (action.type) {
    case 'CHANGE_EXCHANGE_INFO': {
      // const nativeAssetUsdPrice =
      //   action.chain === '???' && action.payload.maticUsdPrice
      //     ? Number(action.payload.maticUsdPrice)
      //     : undefined;
      const {
        volume24h,
        // idexTokenPrice,
        totalVolume,
        totalTrades,
        totalOpenInterest,
      } = action.payload;

      return {
        ...state,
        // nativeAssetUsdPrice,
        katanaChainVolume24hUsd: volume24h,
        // idexUsdcTokenPrice: Number(idexTokenPrice),
        totalOpenInterest,
        totalTrades,
        totalVolume,
        // : action.chain === 'binanceChain'
        // ? {
        //     binanceChainExchangeContract:
        //       action.payload.exchangeContract || undefined,
        //     nativeAssetUsdPrice: action.payload.bnbUsdPrice,
        //     binanceChainVolume24hUsd: action.payload.volume24hUsd,
        //   }
        // : {
        //     ethereumExchangeContract:
        //       action.payload.exchangeContract || undefined,
        //     nativeAssetUsdPrice: action.payload.ethUsdPrice,
        //     etherumVolume24hUsd: action.payload.volume24hUsd,
        //   }),
      };
      // case 'LOAD_OTHER_CHAIN_24H_VOLUMES': {
      //   // const otherChainsVolume = action.payload.reduce((sum, current) => sum + Number(current.volume), 0);
      //   // const totalVolume = otherChainsVolume + Number(state.volume24hUsd);
      //   let ethVolume: string | undefined;
      //   let bscVolume: string | undefined;
      //   action.payload.forEach(item => {
      //     if (item.chain === 'ethereumChain') {
      //       ethVolume = item.volume;
      //     } else if (item.chain === 'binanceChain') {
      //       bscVolume = item.volume;
      //     }
      //   });
      //   return {
      //     ...state,
      //     etherumVolume24hUsd: ethVolume || state.etherumVolume24hUsd,
      //     binanceChainVolume24hUsd: bscVolume || state.binanceChainVolume24hUsd,
      //     // agregated24hUsdVolume: totalVolume,
      //   };
      // }
    }
    // case 'CHANGE_EXCHANGE_NATIVE_ASSET_USD_PRICE':
    //   return {
    //     ...state,
    //     nativeAssetUsdPrice: action.usdPrice,
    //   };
    default:
      return state;
  }
};
